module.exports = __webpack_public_path__ + "static/media/ficus.4f49226b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Homepage/ficus.jpg
// module id = 690
// module chunks = 0